export default __webpack_public_path__ + "static/img/resp_awareness_02.2fafc0e.png";